module.exports = __webpack_public_path__ + "static/media/1024-products---5-image-1.fbf4b471.png";